import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { createAction, props } from '@ngrx/store';

export class GlobalSpinnerSettings {
    color: ThemePalette | undefined = undefined
    mode: ProgressSpinnerMode | undefined = undefined
    value: number | undefined = undefined
    timeoutOffset: number | undefined = undefined
}

export const showGlobalSpinner = createAction(
    '[Shared] show GlobalSpinner',
    (settings: Partial<GlobalSpinnerSettings> | undefined = undefined) => ({ settings: settings })
)

export const hideGlobalSpinner = createAction(
    '[Shared] hide GlobalSpinner'
)